import React, { Component, Fragment } from 'react';
import './Search.css';
// import { withRouter } from 'react-router';
// import { connect } from 'react-redux';
import SearchResult from './SearchResult';
// import ReactDOM from 'react-dom';
import {DelayInput} from 'react-delay-input';

class Search extends Component {
  constructor(props){
    super(props);
    this.state= {
        keySearch : '',
        closeSearch : true
    }
   ;
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }
  handleClick = (e) => {
      if(this.node.contains(e.target)){
          return;
      }
      this.setState({ keySearch: ''});
  }
  render() {
      var key = null;
      if(this.state.keySearch !== ''){
          key = this.state.keySearch;
      }
    return (
       <Fragment>
            <li className="header-search" ref={node => this.node = node}>
                <a onClick={event => this.setState({closeSearch: true})} className="search-btn"><img src="/images/icon-search.png" alt="true" /></a>
                <div className="search-input">
                    <DelayInput type="text" value={this.state.keySearch}  name="keySearch" delayTimeout={1000} onChange={event => this.setState({keySearch: event.target.value})} className="form-control" placeholder="Search something..." />
                    {/*<img src="/images/icon-close.png"  onClick={event => this.setState({keySearch: ''})} alt="true"  className="closes" />*/}
                </div>
                    {
                        this.state.closeSearch === true ? <SearchResult keyword={key}/> : ''
                    }
            </li>
        </Fragment>
    );
  }
}
export default Search;




// WEBPACK FOOTER //
// ./src/components/Search/Search.js